export default __webpack_public_path__ + "static/media/syl.9f88df17.jpg";